export default __webpack_public_path__ + "989057e877d69a847f639b2f1254b8b2.jpg";